import { AxiosInstance, AxiosResponse, CancelToken } from 'axios'
import { DafDefaultQueryParams, UserProps } from '../../../../types/userProps'
import { createRequestConfig } from '../../../../helpers/axiosHelper'

export interface ShoppingBasketDiscountResult {
  statistics: {
    totalCount: number
  }
  rewards: [
    {
      rewardId: number
      type: string
      creditValue: {
        currencyCode: string
        value: number
      }
      costPriceInPoints: number
      minimalSalesOrderValue: number
    }
  ]
}

interface Message {
  message: string
  severity: string
  code: string
  args: string[]
  argsObj: Record<string, any>
}

interface ShoppingBasketDiscountData {
  result: ShoppingBasketDiscountResult
  messages: Message
}

const getShoppingBasketDiscountInformation = (
  queryParams: DafDefaultQueryParams,
  client: AxiosInstance,
  cancelToken: CancelToken,
  user?: UserProps
): Promise<AxiosResponse<ShoppingBasketDiscountData>> =>
  client.get('customer/loyalty/rewards/shopping-basket-discounts', {
    params: queryParams,
    cancelToken,
    ...createRequestConfig(user),
  })

export default getShoppingBasketDiscountInformation
